module.exports = __webpack_public_path__ + "static/img/wr977bb.79cecf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wr977bb.jpg
// module id = 0AtZ
// module chunks = 0